import React, { Component } from "react";
import { Button, Cascader, Select, DatePicker } from "antd";
import SearchRetrieve from "../../common/SearchRetrieve.new";
import API_URL from "../../../common/url";

const Option = Select.Option;

class Filter extends Component {

    handleChange = (value, key) => {
        if (key === 'diseaseId') {
            this.props.onChange(value.value, key);
        } else {
            this.props.onChange(value, key);
        }
    }
    handleFocus = () => {
        this.props.onFocus();
    }

    render() {
        const {
            params,
            search,
            exportData,
            exportCureData,
            businessList,
            areaList,
            versionList,
            windowList,
            researchProductTypeList
        } = this.props;
        const {
            lineOfBusinessId,
            investigationAreaId,
            researchProductTypeId,
            diseaseId,
            empCostBasicParameterVersionId,
            empCostTimeWindowId,
        } = params;
        const businessOption = businessList.filter(el => el.groupId == 1).map(el => <Option value={el.typeConfigureId}>{el.typeValue}</Option>);  //业务线
        const areaOption = areaList.map(el => <Option value={el.investigationAreaId}>{el.investigationAreaName}</Option>); //项目领域
        return (
            <div className="search-bar" style={{ marginBottom: 10 }}>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">业务线</label>
                    <Select
                        style={{ width: 120 }}
                        allowClear
                        placeholder='请选择'
                        value={lineOfBusinessId}
                        onChange={value => this.handleChange(value, 'lineOfBusinessId')}
                    >
                        {businessOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">研究产品类型</label>
                    <Cascader
                        style={{ width: 120 }}
                        allowClear
                        placeholder="请选择"
                        options={researchProductTypeList}
                        value={researchProductTypeId}
                        onChange={value => this.handleChange(value, 'researchProductTypeId')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">项目领域</label>
                    <Select
                        style={{ width: 160 }}
                        placeholder='键入项目领域名称自动检索'
                        allowClear
                        showSearch
                        filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                        value={investigationAreaId}
                        onChange={value => this.handleChange(value, 'investigationAreaId')}
                    >
                        {areaOption}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">疾病</label>
                    <SearchRetrieve
                        keyword='keyword'
                        style={{ width: 160 }}
                        placeholder='键入疾病名称自动检索'
                        params={{ limit: 20 }}
                        url={API_URL.common.queryAllDisease}
                        config={{ id: 'diseaseId', name: 'diseaseName' }}
                        value={diseaseId}
                        onChange={value => this.handleChange(value, 'diseaseId')}
                    />
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">计算基础版本&参数版本</label>
                    <Select
                        style={{ width: 160 }}
                        placeholder='请选择'
                        value={empCostBasicParameterVersionId}
                        onFocus={() => this.handleFocus()}
                        onChange={value => this.handleChange(value, 'empCostBasicParameterVersionId')}
                    >
                        {versionList.map(el => <Option value={el.empCostBasicParameterVersionId}>{el.versionNumShow}</Option>)}
                    </Select>
                </div>
                <div className="search-item">
                    <label htmlFor="" className="ui-label">窗口期</label>
                    <Select
                        style={{ width: 160 }}
                        placeholder='请选择'
                        value={empCostTimeWindowId}
                        onChange={value => this.handleChange(value, 'empCostTimeWindowId')}
                    >
                        {windowList.map(el => <Option value={el.empCostTimeWindowId}>{el.dateShow}</Option>)}
                    </Select>
                </div>
                <div className="search-item">
                    <Button type="primary" onClick={search}>搜索</Button>
                    <Button type="primary" onClick={exportData}>导出</Button>
                    <Button className="btn-yellow" onClick={exportCureData}>导出固化数据</Button>
                </div>
            </div>
        )
    }
}

export default Filter



// WEBPACK FOOTER //
// ./src/components/clinicalEvaluation/standardVisitPrice/Filter.js